import { startIssueDialog } from '@issue-detail/utils/performance';
import { computed } from '@vue/composition-api';

import { ActionStore } from './action';
import { FieldsStore } from './fields';
import { TurnPageOptionsPart } from './turnPage';
import { resolveUrl } from '@zk/framework-vue';
// @ts-ignore
import config from 'common-module/src/config/index';
export interface RelationNavigationRecord {
  oppositeType: string;
  oppositeTypeLabelI18n: string;
  id: number;
  summary: string;
  turnPage?: TurnPageOptionsPart;
  commentId?: number;
}

export interface RelationNavigationParam {
  id: number;
  oppositeType: string;
  oppositeTypeLabelI18n: string;
  projectId: string;
  target: '_blank' | '_self';
}

const getLeftRightFieldAreaScrollTop = () => {
  const leftFieldArea = document.querySelector(
    '.issue-content-left-field-area .el-scrollbar__wrap'
  );
  const rightFieldArea = document.querySelector(
    '.issue-content-right-field-area .el-scrollbar__wrap'
  );
  return [leftFieldArea?.scrollTop || 0, rightFieldArea?.scrollTop || 0] as [
    number,
    number
  ];
};

export const useRelationNavigation = (
  actionStore: ActionStore,
  fieldsStore: FieldsStore,
  waitChangedFlushOnEdit: () => Promise<void>
) => {
  const hasNavigationStack = computed(() =>
    actionStore.action.value?.type === 'Edit'
      ? actionStore.action.value.relationNavigationStack.length > 0
      : false
  );

  const currentNavigationRecord = computed(() =>
    actionStore.action.value?.type === 'Edit'
      ? actionStore.action.value.relationNavigationStack[0]
      : null
  );

  const scrollTopStack = [] as [number, number][];

  actionStore.onClose(() => {
    scrollTopStack.length = 0;
  });

  const navigationToIssue = async ({
    id,
    oppositeType,
    oppositeTypeLabelI18n,
    projectId,
    target
  }: RelationNavigationParam) => {
    if (target === '_blank' || actionStore.action.value?.type === 'Create') {
      window.open(
        resolveUrl(`${config.VUE_APP_PMS_URL}/work/list?pid=${projectId}&issueid=${id}`),
        '_blank'
      );
    } else if (
      target === '_self' &&
      actionStore.action.value?.type === 'Edit'
    ) {
      await waitChangedFlushOnEdit();

      scrollTopStack.unshift(getLeftRightFieldAreaScrollTop());
      startIssueDialog();
      actionStore.editIssue(id, undefined, [
        {
          oppositeType,
          oppositeTypeLabelI18n,
          id: actionStore.action.value.issueId,
          summary: fieldsStore.fieldValues.value.summary,
          turnPage: actionStore.turnPageOptions.value
        },
        ...actionStore.action.value.relationNavigationStack
      ]);
    }
  };

  const navigationGoBack = () => {
    if (
      currentNavigationRecord.value &&
      actionStore.action.value?.type === 'Edit'
    ) {
      actionStore.editIssue(
        currentNavigationRecord.value.id,
        currentNavigationRecord.value.turnPage,
        actionStore.action.value!.relationNavigationStack.slice(1),
        undefined,
        undefined,
        scrollTopStack.shift()
      );
    }
  };

  return {
    hasNavigationStack,
    currentNavigationRecord,
    navigationToIssue,
    navigationGoBack
  };
};
